"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    InputButtonWrapper: ()=>InputButtonWrapper
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const field_namespaceObject = require("@base-ui-components/react/field");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Tooltip_index_cjs_namespaceObject = require("../Tooltip/index.cjs");
const external_react_namespaceObject = require("react");
const InputButtonWrapper = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(({ styles, iconLeft, iconRight, handleButtonClick, isDisabled = false, buttonText, errorMessage, tooltipSideOffset = 0, label, isLabelHidden, isToggled = false, ...props }, ref)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("button", {
        ...props,
        type: "button",
        onClick: handleButtonClick,
        "aria-disabled": isDisabled,
        "aria-pressed": isToggled,
        disabled: isDisabled,
        className: styles.buttonWrapper(),
        ref: ref,
        children: [
            iconLeft ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: styles.iconLeft(),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                    iconName: iconLeft,
                    size: "24"
                })
            }) : null,
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: styles.buttonText(),
                children: [
                    isLabelHidden ? null : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                        className: styles.labelSlot(),
                        children: label
                    }),
                    buttonText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                        className: styles.sublabelSlot(),
                        children: buttonText
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(field_namespaceObject.Field.Error, {
                match: !!errorMessage,
                className: styles.errorTextSlot(),
                "aria-live": "assertive",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tooltip_index_cjs_namespaceObject.Tooltip, {
                    defaultOpen: true,
                    open: !!errorMessage,
                    emphasis: true,
                    sideOffset: tooltipSideOffset,
                    closeDelay: 90000,
                    color: "error",
                    align: "end",
                    side: "bottom",
                    triggerNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                        iconName: "error",
                        size: "20"
                    }),
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        children: errorMessage
                    })
                })
            }),
            iconRight ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: styles.iconRight(),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                    iconName: iconRight,
                    size: "20"
                })
            }) : null
        ]
    }));
exports.InputButtonWrapper = __webpack_exports__.InputButtonWrapper;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "InputButtonWrapper"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
